import { render } from "./notFound.vue?vue&type=template&id=5804f527"
const script = {}

import "./notFound.vue?vue&type=style&index=0&id=5804f527&lang=scss"

import exportComponent from "/builds/mit/fe/NEWRR/business-fe/global-os/global-retail-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__